import LeanerTbl from "./LeanerTbl.js";
import LeanerAssingmentTbl from "./LeanerAssingmentTbl.js";
import LeanerScomTbl from "./LeanerScomTbl.js";
import Leanerdetails from "./Leanerdetails.js";

export default class LearnerReport extends React.Component{
  constructor(props){
    super(props);
    this.box   = React.createRef();
    window.leanerDropdown = this.leanerDropdown;
    console.log('props are ',props);
    this.state = { isOPenDropDown:false,learnerid: this.props['match']['params']['id'], learnercourseid: this.props['match']['params']['cid'], activeTabs: 'testTab', leanerDropdown: this.props['match']['params']['cid']};//testTab
  }

  leanerTestTabs = () => {
    return(<div className="tab-pane fade showed active" id="testreport" role="tabpanel" aria-labelledby="test-tab">
      <div className="bc-datatable-holder leaner-report-prgress-details-sec">
        <LeanerTbl data={[]} learnerid={this.state.learnerid} learnerCourseid={this.state.learnercourseid} leanerDropdown={this.state.leanerDropdown} />
      </div>
    </div>
    );
  }

  leanerAssingmentTabs = () => {
    return (<div className="tab-pane fade  showed active" id="assignmentreport" role="tabpanel" aria-labelledby="assignment">
      <div className="bc-datatable-holder leaner-report-prgress-details-sec">
        <LeanerAssingmentTbl data={[]} learnerid={this.state.learnerid} learnerCourseid={this.state.leanerDropdown} />
      </div>
    </div>
    );
  }
  leanerScomTabs = () => {
    return (<div className="tab-pane fade  showed active" id="assignmentreport" role="tabpanel" aria-labelledby="assignment">
      <div className="bc-datatable-holder leaner-report-prgress-details-sec">
        <LeanerScomTbl data={[]} learnerid={this.state.learnerid} learnerCourseid={this.state.leanerDropdown} />
      </div>
    </div>
    );
  }

  exportSummary = () => {
    location.href = admin_url + 'Consolidate_reports/leaner_export/' + this.state.learnerid + '/' + this.state.leanerDropdown+__setSsAuthUrl;
  }

  leanerDropdown = (e) => {
    this.setState({ leanerDropdown: e });
    this.setState({ activeTabs: 'testTab',isOPenDropDown:false });
    document.removeEventListener('click', this.handleOutsideClick);

    location.href = admin_url + `Consolidate_reports${__setSsAuthUrl}#/learner_report/${this.state.learnerid}/${e}`;
  }
componentDidMount(){
  
}
componentWillUnmount(){
  
}

SetIsopenToggle = ()=>{
  this.setState({isOPenDropDown:!this.state.isOPenDropDown},()=>{
    document.addEventListener('click', this.handleOutsideClick);
  });
}

handleOutsideClick = (event) => {
  if (this.box && !this.box.current.contains(event.target)) {
    document.removeEventListener('click', this.handleOutsideClick);
    this.setState({isOPenDropDown:!this.state.isOPenDropDown});
  }
}

  render(){
    
 return (
 <section className="content-wrap learner-progres-report-sec">
 
     <div className="container-fluid">
       <div className="leaner-sltd-header rTable w-100">
         <div className="rTableRow-align">
          
           <div className="align-center d-flex rTableCell">
             <span className="leaner-back-btn">
               <a href={`${admin_url}consolidate_reports${__setSsAuthUrl}#/`}>
               <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} viewBox="0 0 23 24.241">
                 <g id="Icon_feather-arrow-left" data-name="Icon feather-arrow-left" transform="translate(1.5 2.121)">
                   <path id="Path_221" data-name="Path 221" d="M27.5,18H7.5" transform="translate(-7.5 -8)" fill="none" stroke="#2e3e4e" strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} />
                   <path id="Path_222" data-name="Path 222" d="M18,27.5,7.5,17.5,18,7.5" transform="translate(-7.5 -7.5)" fill="none" stroke="#2e3e4e" strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} />
                 </g>
               </svg>
               </a>
             </span>
 
             <div className="leaner-user-id">
               <span className="leaner-user-idtxt" id="learnerProfileImage"></span>
               <div className="leaner-idtxt">
                 <h4 id="leanerName"></h4>
                 <p id="leanerEmail"></p>
               </div> 
             </div>
  
             <div ref={this.box} className="leaner-course-sltd select" >
               <div className={`custom-select ${this.state.isOPenDropDown?'active':''}`} onClick={this.SetIsopenToggle} id="setActiveCourseName"></div>
               <ul className={`select-options ${this.state.isOPenDropDown?'show':''}`} id="leanerDropdown">
                 </ul></div>
             {/* <div className="leaner-course-sltd">
               <select id="leanerDropdown" className="form-control" onChange={e => this.leanerDropdown(e.target.value)}>
                
                <option  value='1'>one</option>
                <option value='2'>Two</option>
                <option value='3'>Three</option>
                
               </select>
             </div>
 
             <div className="leaner-course-sltd-price" id="coursePrice"></div>
             <div className="leaner-course-report-status active" id="courseStatus"></div>
  
             {/* <div className="leaner-report-course-prev"><svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" version="1.1" width={20} height={20} viewBox="0 0 256 256" xmlSpace="preserve">
               <desc>Created with Fabric.js 1.7.22</desc>
               <defs>
               </defs>
               <g transform="translate(128 128) scale(0.72 0.72)" style={{}}>
                 <g style={{ stroke: 'none', strokeWidth: 0, strokeDasharray: 'none', strokeLinecap: 'butt', strokeLinejoin: 'miter', strokeMiterlimit: 10, fill: 'none', fillRule: 'nonzero', opacity: 1 }} transform="translate(-175.05 -175.05000000000004) scale(3.89 3.89)">
                   <path d="M 44.759 63.847 L 56.954 90 l 9.909 -9.079 l 13.325 -1.755 L 68.323 53.721 c -9.609 -0.082 -17.439 3.046 -23.082 10.126" style={{ stroke: 'none', strokeWidth: 1, strokeDasharray: 'none', strokeLinecap: 'butt', strokeLinejoin: 'miter', strokeMiterlimit: 10, fill: 'rgb(237,99,98)', fillRule: 'nonzero', opacity: 1 }} transform=" matrix(1 0 0 1 0 0) " strokeLinecap="round" />
                   <path d="M 45.241 63.847 L 33.046 90 l -9.909 -9.079 L 9.812 79.166 l 11.865 -25.445 C 33.52 52.826 41.539 56.026 45.241 63.847 z" style={{ stroke: 'none', strokeWidth: 1, strokeDasharray: 'none', strokeLinecap: 'butt', strokeLinejoin: 'miter', strokeMiterlimit: 10, fill: 'rgb(233,84,84)', fillRule: 'nonzero', opacity: 1 }} transform=" matrix(1 0 0 1 0 0) " strokeLinecap="round" />
                   <path d="M 45 63.847 c 17.631 0 31.923 -14.293 31.923 -31.923 S 62.631 0 45 0 C 34.483 21.782 33.645 43.104 45 63.847 z" style={{ stroke: 'none', strokeWidth: 1, strokeDasharray: 'none', strokeLinecap: 'butt', strokeLinejoin: 'miter', strokeMiterlimit: 10, fill: 'rgb(255,204,91)', fillRule: 'nonzero', opacity: 1 }} transform=" matrix(1 0 0 1 0 0) " strokeLinecap="round" />
                   <path d="M 45 63.847 c -17.631 0 -31.923 -14.293 -31.923 -31.923 S 27.369 0 45 0 v 63.814" style={{ stroke: 'none', strokeWidth: 1, strokeDasharray: 'none', strokeLinecap: 'butt', strokeLinejoin: 'miter', strokeMiterlimit: 10, fill: 'rgb(253,188,75)', fillRule: 'nonzero', opacity: 1 }} transform=" matrix(1 0 0 1 0 0) " strokeLinecap="round" />
                   <path d="M 38.778 54.411 c -0.092 0 -0.186 -0.013 -0.279 -0.039 C 26.122 50.786 18.967 37.8 22.552 25.422 c 0.153 -0.531 0.707 -0.836 1.239 -0.682 c 0.53 0.153 0.836 0.708 0.682 1.239 c -3.277 11.318 3.264 23.193 14.583 26.471 c 0.53 0.154 0.836 0.709 0.682 1.239 C 39.611 54.127 39.211 54.411 38.778 54.411 z" style={{ stroke: 'none', strokeWidth: 1, strokeDasharray: 'none', strokeLinecap: 'butt', strokeLinejoin: 'miter', strokeMiterlimit: 10, fill: 'rgb(236,153,34)', fillRule: 'nonzero', opacity: 1 }} transform=" matrix(1 0 0 1 0 0) " strokeLinecap="round" />
                   <path d="M 66.487 39.146 c -0.092 0 -0.186 -0.013 -0.278 -0.04 c -0.53 -0.154 -0.836 -0.708 -0.683 -1.239 c 1.589 -5.483 0.946 -11.256 -1.808 -16.256 c -2.755 -5 -7.291 -8.628 -12.774 -10.216 c -0.53 -0.153 -0.836 -0.708 -0.683 -1.239 c 0.154 -0.53 0.708 -0.835 1.239 -0.682 c 5.996 1.736 10.957 5.704 13.969 11.172 c 3.013 5.468 3.715 11.781 1.979 17.777 C 67.321 38.862 66.922 39.146 66.487 39.146 z" style={{ stroke: 'none', strokeWidth: 1, strokeDasharray: 'none', strokeLinecap: 'butt', strokeLinejoin: 'miter', strokeMiterlimit: 10, fill: 'rgb(236,153,34)', fillRule: 'nonzero', opacity: 1 }} transform=" matrix(1 0 0 1 0 0) " strokeLinecap="round" />
                   <path d="M 37.058 47.693 c -0.225 0 -0.449 -0.075 -0.633 -0.227 c -0.374 -0.306 -0.476 -0.836 -0.241 -1.259 l 6.723 -12.121 l -5.127 -2.93 c -0.283 -0.162 -0.47 -0.451 -0.5 -0.776 c -0.03 -0.325 0.1 -0.644 0.348 -0.854 l 14.177 -12.04 c 0.359 -0.304 0.878 -0.317 1.253 -0.034 c 0.374 0.285 0.499 0.791 0.302 1.217 l -5.036 10.86 l 5.096 2.766 c 0.289 0.157 0.482 0.447 0.517 0.775 c 0.034 0.328 -0.095 0.651 -0.346 0.865 L 37.706 47.455 C 37.52 47.613 37.289 47.693 37.058 47.693 z" style={{ stroke: 'none', strokeWidth: 1, strokeDasharray: 'none', strokeLinecap: 'butt', strokeLinejoin: 'miter', strokeMiterlimit: 10, fill: 'rgb(236,153,34)', fillRule: 'nonzero', opacity: 1 }} transform=" matrix(1 0 0 1 0 0) " strokeLinecap="round" />
                 </g>
               </g>
             </svg>
               <a className="text-nowrap">View Certificate</a>
             </div> */}
 
           </div>
 

           <div className="rTableCell">
             <div className="float-r learner-report-export-txt" onClick={() => this.exportSummary()}>
               <svg xmlns="http://www.w3.org/2000/svg" width="15.737" height="13.267" viewBox="0 0 15.737 13.267">
                 <g id="Group_139" data-name="Group 139" transform="translate(-1259.4 -40)">
                   <path id="Path_28" data-name="Path 28" d="M2.674,5.284h7.534a.423.423,0,0,1,.419.428v5.135h1.256V5.712A1.693,1.693,0,0,0,10.208,4H2.674A1.693,1.693,0,0,0,1,5.712v9.843a1.693,1.693,0,0,0,1.674,1.712h7.534a1.682,1.682,0,0,0,1.621-1.284H10.417q-.075,0-.149,0a.409.409,0,0,1-.06,0H2.674a.423.423,0,0,1-.419-.428V5.712A.423.423,0,0,1,2.674,5.284Z" transform="translate(1258.4 36)" fill="#2e3e4e" fillRule="evenodd" opacity="0.8" />
                   <path id="Union_1" data-name="Union 1" d="M-7926.283-1216.05v-.728h-2.364a1.352,1.352,0,0,1-1.354-1.351,1.354,1.354,0,0,1,1.354-1.353h2.364v-1.065a.452.452,0,0,1,.712-.368l3.165,2.249a.451.451,0,0,1,0,.734l-3.165,2.251a.447.447,0,0,1-.259.083A.452.452,0,0,1-7926.283-1216.05Z" transform="translate(9197.354 1266.51)" fill="#2e3e4e" opacity="0.8" />
                   <path id="Path_30" data-name="Path 30" d="M9.979,11.852h-1.8a.676.676,0,0,1,0-1.352h1.8a.676.676,0,0,1,0,1.352Z" transform="translate(1254.647 31.266)" fill="#2e3e4e" opacity="0.8" />
                   <path id="Path_31" data-name="Path 31" d="M9.979,16.852h-1.8a.676.676,0,0,1,0-1.352h1.8a.676.676,0,0,1,0,1.352Z" transform="translate(1254.647 28.394)" fill="#2e3e4e" opacity="0.8" />
                   <path id="Path_32" data-name="Path 32" d="M9.979,21.852h-1.8a.676.676,0,1,1,0-1.352h1.8a.676.676,0,1,1,0,1.352Z" transform="translate(1254.647 25.521)" fill="#2e3e4e" opacity="0.8" />
                   <path id="Path_33" data-name="Path 33" d="M9.979,26.852h-1.8a.676.676,0,1,1,0-1.352h1.8a.676.676,0,1,1,0,1.352Z" transform="translate(1254.647 22.649)" fill="#2e3e4e" opacity="0.8" />
                 </g>
               </svg>
               Export
             </div>
           </div>
         </div>
       </div>
     </div>
     <Leanerdetails />
 
     <div className="leaner-report-tab">
 
       <div className="container-fluid">
         <div>
           <ul className="nav nav-tabs" id="myTab" role="tablist">
             <li className={`nav-item ${this.state.activeTabs == 'testTab' && 'active'}`} onClick={() => { this.setState({ activeTabs:'testTab'})}} >
               <a className="nav-link" id="test-tab" data-toggle="tab" href="#testreport" role="tab" aria-controls="testreport" aria-selected="true">Test Report</a>
             </li>
             <li className={`nav-item ${this.state.activeTabs == 'assingmentTab' && 'active'}`} onClick={() => { this.setState({ activeTabs: 'assingmentTab' }) }} >
               <a className="nav-link" id="assignment-tab" data-toggle="tab" href="#assignmentreport" role="tab" aria-controls="assignmentreport" aria-selected="false">Assignment Report</a>
             </li>
             <li className={`nav-item ${this.state.activeTabs == 'scomTab' && 'active'}`} onClick={() => { this.setState({ activeTabs: 'scomTab' }) }} >
               <a className="nav-link" id="scrom-tab" data-toggle="tab" href="#scromreport" role="tab" aria-controls="scromreport" aria-selected="false">Scorm Report</a>
            </li>
           </ul>
         </div>
       </div>
 


       <div className="leaner-report-results">
         <div className="tab-content mt-4" id="myTabContent">

           {this.state.activeTabs == 'testTab' && this.leanerTestTabs()}
           {this.state.activeTabs == 'assingmentTab' && this.leanerAssingmentTabs()}
           {this.state.activeTabs == 'scomTab' && this.leanerScomTabs()}
           
 
        
 


         </div>
       </div>
     </div>
 
   </section>)

  }
}
